var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "overlay" } }, [
    _c("div", { attrs: { id: "content" } }, [
      _vm.isMessage
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger alert-margin",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _vm._e(),
      _c("div", { staticClass: "row row-margin" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-outline-info modal-close",
              on: { click: _vm.closeModal },
            },
            [_vm._v("キャンセルする")]
          ),
        ]),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "empty-row" }),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-1", staticStyle: { "white-space": "nowrap" } },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle.collapse-1",
                    modifiers: { "collapse-1": true },
                  },
                ],
                attrs: { variant: "btn btn-outline-primary" },
              },
              [
                _c("span", {
                  class: _vm.actionToggle,
                  staticStyle: { display: "inline-block" },
                  attrs: { id: "Arrow" },
                }),
                _vm._v("説明 "),
              ]
            ),
          ],
          1
        ),
        this.$store.state.excludedUserData.length > 0
          ? _c("div", { staticClass: "d-flex align-items-end ml-4" }, [
              _vm._m(1),
            ])
          : _c("div", { staticClass: "d-flex align-items-end ml-4" }, [
              _c("h6", { staticClass: "text-left" }, [
                _vm._v(
                  " 「共通連絡先の対象から外す」設定されているユーザーは削除対象となります。 "
                ),
              ]),
            ]),
      ]),
      _c(
        "div",
        { staticClass: "w-100" },
        [
          _c(
            "b-collapse",
            {
              attrs: { id: "collapse-1" },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c("b-card", { staticClass: "custom-card" }, [
                _c("div", { staticClass: "row" }, [
                  this.$store.state.excludedUserData.length > 0
                    ? _c("div", { staticClass: "col-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm col-form-label",
                            staticStyle: {
                              "white-space": "normal",
                              "word-break": "break-word",
                              width: "100%",
                              "font-size": "14px",
                            },
                          },
                          [
                            _vm._v(" 「追加のみ反映する」ボタン "),
                            _c("br"),
                            _vm._v(
                              "最新のユーザーから共通連絡先に反映されます。下記一覧のユーザーは削除されずに残ります。 "
                            ),
                            _c("br"),
                            _c("br"),
                            _vm._v(" 「削除も反映する」ボタン "),
                            _c("br"),
                            _vm._v(
                              "最新のユーザーから共通連絡先に反映されます。下記一覧のユーザーは全て削除されます。 "
                            ),
                            _c("br"),
                            _vm._v(
                              "※共通連絡先に残すユーザーは、ユーザー変更画面で「共通連絡先の対象から外す」設定を解除してください。 "
                            ),
                          ]
                        ),
                      ])
                    : _c("div", { staticClass: "col-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm col-form-label",
                            staticStyle: {
                              "white-space": "normal",
                              "word-break": "break-word",
                              width: "100%",
                              "font-size": "14px",
                            },
                          },
                          [
                            _vm._v(" 「最新のユーザーを反映する」ボタン "),
                            _c("br"),
                            _vm._v(
                              "最新のユーザーから共通連絡先に反映されます。 "
                            ),
                            _c("br"),
                            _c("br"),
                            _vm._v(" 「削除も反映する」ボタン "),
                            _c("br"),
                            _vm._v(
                              "削除対象のユーザーがいないため表示されません。 "
                            ),
                          ]
                        ),
                      ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "table-scroll" }, [
        _c("table", { staticClass: "table table-sm table-hover form-table" }, [
          _vm._m(2),
          this.$store.state.excludedUserData.length > 0
            ? _c(
                "tbody",
                _vm._l(
                  this.$store.state.excludedUserData,
                  function (excludedUsers, index) {
                    return _c("tr", { key: excludedUsers.id }, [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v(_vm._s(index + 1)),
                      ]),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "max-width": "120px",
                            "white-space": "nowrap",
                            overflow: "hidden",
                            "text-overflow": "ellipsis",
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(excludedUsers.user.userName) + " "
                          ),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "max-width": "120px",
                            "white-space": "nowrap",
                            overflow: "hidden",
                            "text-overflow": "ellipsis",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                excludedUsers.user.organization.organizationName
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.moment(excludedUsers.user.disableAt))
                        ),
                      ]),
                    ])
                  }
                ),
                0
              )
            : _c("tbody", [_vm._m(3)]),
        ]),
      ]),
      _c("div", { staticClass: "empty-row-wide" }),
      this.$store.state.excludedUserData.length > 0
        ? _c("div", { staticClass: "row", attrs: { id: "title" } }, [_vm._m(4)])
        : _vm._e(),
      _c("div", { staticClass: "empty-row" }),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 d-flex justify-content-center" }, [
          this.$store.state.excludedUserData.length > 0
            ? _c(
                "button",
                {
                  staticClass: "btn btn-outline-success mr-5 mb-3",
                  attrs: { id: "onlyAddBtn", type: "button" },
                  on: { click: _vm.onlyAddCommon },
                },
                [
                  _vm._v("追加のみ反映する "),
                  _c(
                    "b-tooltip",
                    {
                      attrs: {
                        target: "onlyAddBtn",
                        variant: "secondary",
                        triggers: "hover",
                      },
                    },
                    [
                      _vm._v(" 最新のユーザーを"),
                      _c("br"),
                      _vm._v("共通連絡先に反映します。"),
                      _c("br"),
                      _vm._v("上記の連絡先は削除されず"),
                      _c("br"),
                      _vm._v("共通連絡先に残ります。 "),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          this.$store.state.excludedUserData.length > 0
            ? _c(
                "button",
                {
                  staticClass: "btn btn-outline-warning custom-btn mb-3",
                  attrs: { id: "removeAndAddBtn", type: "button" },
                  on: { click: _vm.removeAndAddCommon },
                },
                [
                  _vm._v("削除も反映する "),
                  _c(
                    "b-tooltip",
                    {
                      attrs: {
                        target: "removeAndAddBtn",
                        variant: "secondary",
                        triggers: "hover",
                      },
                    },
                    [
                      _vm._v(" 最新のユーザーを"),
                      _c("br"),
                      _vm._v("共通連絡先に反映します。"),
                      _c("br"),
                      _vm._v("上記の連絡先は"),
                      _c("br"),
                      _vm._v("共通連絡先およびお気に入り"),
                      _c("br"),
                      _vm._v("から完全に削除されます。 "),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          this.$store.state.excludedUserData.length === 0
            ? _c(
                "button",
                {
                  staticClass: "btn btn-outline-success mb-3",
                  attrs: { id: "onlyAddBtn", type: "button" },
                  on: { click: _vm.onlyAddCommon },
                },
                [_vm._v("最新のユーザーを反映する")]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-12 text-center" }, [
        _c("h4", [_vm._v("最新のユーザーを共通連絡先に反映する")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", { staticClass: "text-left" }, [
      _vm._v(" 反映時に削除されるユーザーがいます。"),
      _c("br"),
      _vm._v(
        "「共通連絡先の対象から外す」設定されている下記ユーザーが削除対象です。 "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          {
            staticStyle: { width: "10px", border: "none" },
            attrs: { scope: "col" },
          },
          [_vm._v("#")]
        ),
        _c(
          "th",
          {
            staticStyle: { width: "120px", border: "none" },
            attrs: { scope: "col" },
          },
          [_vm._v("連絡先名")]
        ),
        _c(
          "th",
          {
            staticStyle: { width: "120px", border: "none" },
            attrs: { scope: "col" },
          },
          [_vm._v("所属")]
        ),
        _c(
          "th",
          {
            staticStyle: { width: "80px", border: "none" },
            attrs: { scope: "col" },
          },
          [_vm._v("アカウント廃止日")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c(
        "td",
        {
          staticClass: "text-center",
          staticStyle: { "padding-top": "30px", "font-size": "18px" },
          attrs: { colspan: "4" },
        },
        [_vm._v("削除対象のユーザーはいません。")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("h5", [_vm._v("操作を選択してください")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }